import { computed, inject } from 'vue';
import { useGetting_StartedQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { envConfig } from '@/services/features';

export const useGettingStarted = () => {
  const coordinatorsService = inject(IKCoordinatorsService);
  const coordinatorId = computed(() => coordinatorsService?.selectedCoordinator.value || '');

  const GQL_gettingStarted = useGetting_StartedQuery({
    coordinatorId: coordinatorId.value,
    endTime: new Date().getTime(),
  });
  const excludeCoordinator = 1;
  const agentsAdded = computed(() => (GQL_gettingStarted.result.value?.ibManagerEntities?.agents?.totalCount || 1) - excludeCoordinator);
  const buildsCreated = computed(() => GQL_gettingStarted.result.value?.ibManagerEntities?.buildsSummary?.totalBuilds);
  const fqdn = computed(() => GQL_gettingStarted.result.value?.ibManagerEntities?.systemInfo?.fqdn);
  const ip = computed(() => GQL_gettingStarted.result.value?.ibManagerEntities?.systemInfo?.ip);
  const ibManagerPort = computed(() => GQL_gettingStarted.result.value?.ibManagerEntities?.settings?.common.ibManager?.ibManagerPort || envConfig.ibManagerPort);
  const daysLeft = computed(() => GQL_gettingStarted.result.value?.ibManagerEntities?.license?.expirationInfo?.daysLeft);
  const hostAddress = computed(() => ip.value || fqdn.value || '');

  return {
    GQL_gettingStarted,
    agentsAdded,
    buildsCreated,
    hostAddress,
    ibManagerPort,
    daysLeft,
  };
};
